<template>
<div>
  <div class="content" style="width: auto">
    <div class="cont-list">
      <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
    </div>

    <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
      <div class="edit-card">
        <div style="width: 88%; display: flex">
          <div class="start-label" />
          <span class="text">请领基础信息</span>
        </div>
        <el-row>
          <el-col :span="4" :class="!getIsView()?'viewCol':''">
            <el-form-item prop="no" label="备货请领单号" v-if="getIsView()">
              <el-input disabled v-model="form.no"></el-input>
            </el-form-item>
            <span class="viewText" v-else>备货请领单号:{{ form.no }} </span>
          </el-col>    
          <el-col :span="4" :class="!getIsView()?'viewCol':''">
            <el-form-item prop="applyDeptName" label="请领科室" v-if="getIsView()">
              
              <el-select v-if="system_setting.IsUseWard" v-model="form.applyDeptName" placeholder="请选择" :disabled="!editMode" style="width: 100%" filterable :filter-method="getDeptAndWards" @change="applyDeptChange1">
                <el-option v-for="item in STATIC_DeptAndWards" :key="item.idGroup" :label="item.deptNo+' '+item.deptName +' '+(item.wardName?item.wardName:'')" :value="item.idGroup"></el-option>
              </el-select>
              <!--12  -->
              <el-select v-else v-model="form.applyDeptName" placeholder="请选择" :disabled="!editMode" style="width: 100%" filterable :filter-method="getDeptsBySessionDeptId" @change="applyDeptChange">
                <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.no+' '+item.name" :value="item.id"></el-option>
              </el-select>

            </el-form-item>
            <span class="viewText" v-else>请领科室:{{ form.applyDeptName }} </span>
          </el-col>
          <el-col :span="4" :class="!getIsView()?'viewCol':''">
            <el-form-item prop="warehouseName" label="目标库房" v-if="getIsView()">
              <el-select v-model="form.warehouseName" placeholder="请选择" :disabled="!editMode" style="width: 100%" filterable :filter-method="getWarehouseList" @change="oneLevelWarehouseChange">
                <el-option v-for="item in STATIC_OneLevelWarehouses" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <span class="viewText" v-else>目标库房:{{ form.warehouseName }} </span>
          </el-col>
          <el-col :span="4" :class="!getIsView()?'viewCol':''">
            <el-form-item prop="oneLevelWarehouseManagerId" label="目标库房库管员" v-if="getIsView()">
              <el-input disabled v-model="form.warehouseManagerName"></el-input>
            </el-form-item>
            <span class="viewText" v-else>目标库房库管员:{{ form.warehouseManagerName }} </span>
          </el-col>
          <el-col :span="4" :class="!getIsView()?'viewCol':''">
            <el-form-item prop="pressingState" label="紧急标识" v-if="getIsView()">
              <el-select v-model="form.pressingState" :disabled="!editMode" placeholder="请选择" style="width: 100%">
                <el-option v-for="item in OrderPressingOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <span class="viewText" v-else>紧急标识:{{ OrderPressingOptions.find(item => item.id === form.pressingState)?.name }} </span>
          </el-col>
          <el-col :span="4" :class="!getIsView()?'viewCol':''">
            <el-form-item label="创建时间" prop="createdTime" v-if="getIsView()">
              <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
              </el-date-picker>
            </el-form-item>
            <span class="viewText" v-else>创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
          </el-col>
        </el-row>

        <el-row>
  
          <el-col :span="3" :class="!getIsView()?'viewCol':''">
            <el-form-item prop="totalNumber" label="申请总数量" v-if="getIsView()">
              <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber" type="number"></el-input>
            </el-form-item>
            <span class="viewText" v-else>申请总数量:{{ form.totalNumber }} </span>
          </el-col>
          <el-col :span="3" :class="!getIsView()?'viewCol':''">
            <el-form-item prop="totalAmount" label="申请总金额" v-if="getIsView()">
              <el-input type="number" disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
            </el-form-item>
            <span class="viewText" v-else>申请总金额:{{ form.totalAmount }} </span>
          </el-col>
          <el-col :span="4" :class="!getIsView()?'viewCol':''">
            <el-form-item prop="totalAmount" label="发起人" v-if="getIsView()">
              <el-input type="text" disabled placeholder="请输入总金额" v-model="form.createdUserName"></el-input>
            </el-form-item>
            <span class="viewText" v-else>发起人:{{ form.createdUserName }} </span>
          </el-col>
          <el-col :span="4" :class="!getIsView()?'viewCol':''">
            <el-form-item prop="totalAmount" label="所属科室" v-if="getIsView()">
              <el-input type="text" disabled placeholder="请输入总金额" v-model="form.ownerDeptName"></el-input>
            </el-form-item>
            <span class="viewText" v-else>所属科室:{{ form.ownerDeptName }} </span>
          </el-col>
          <el-col :span="8" :class="!getIsView()?'viewCol':''">
            <el-form-item label="备注" prop="remark" v-if="getIsView()">
              <el-input :disabled="!editMode" placeholder="备注" v-model="form.remark"></el-input>
            </el-form-item>
            <span class="viewText" v-else>备注:{{ form.remark }} </span>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px"></el-row>
      </div>

      <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
        <div style="width: 88%; display: flex">
          <div class="start-label" />
          <span class="text">申请明细</span>
        </div>

        <div v-if="editMode" style="margin: 20px 0 12px 10px">
          <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
          <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
        </div>
        <div v-else style="margin-top: 20px"></div>

        <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" max-height="600" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
          <el-table-column type="index"  width="50" fixed="left"> </el-table-column>
          <el-table-column type="selection" width="55"  align="center" fixed="left"></el-table-column>
          <el-table-column prop="productName" label="产品" width="180" fixed="left"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="specName" fixed="left" label="产品规格" width="180"></el-table-column>
          <el-table-column prop="supplierProductNo" label="供应商产品编码"   width="180"></el-table-column>
          <el-table-column prop="number" label="申请数量" width="120" :key="'number'"></el-table-column>
          <el-table-column prop="minUnit" label="最小单位" width="100"></el-table-column>
          <el-table-column prop="packSpec" label="包装规格" width="100"></el-table-column>
          <el-table-column prop="stockNumber" label="科室库存" width="100"></el-table-column>
          <el-table-column prop="oneLevelStockNumber" label="目标库房库存" width="120"></el-table-column>
          <el-table-column prop="price" label="单价" width="120"></el-table-column>
          <el-table-column prop="amount" label="小计" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="supplierName" label="供应商" width="180"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="manufacturerName" label="生产厂家" width="120"></el-table-column>
          <el-table-column prop="receivedNumber" label="已领数量" width="120"></el-table-column>
          <el-table-column prop="productRegistCertNo" label="注册证号" width="200"></el-table-column>
          <el-table-column prop="remark" label="备注" width="200"></el-table-column>
          <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码" width="200"></el-table-column>

          <el-table-column fixed="right" width="160" label="完成情况">
            <template slot-scope="scope">
              <el-progress :text-inside="true" :stroke-width="20" :percentage="getPercentage(scope.row.receivedNumber, scope.row.number)" color="#42b983" />
            </template>
          </el-table-column>
        </el-table>
      </div>

      <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
    </el-form>

    <el-dialog title="产品信息" :visible.sync="openSubformModal" :center="true" width="1100px" :before-close="cancelChildDialog" :close-on-click-modal="false">
      <el-form label-position="top" label-width="80px" ref="childForm" :model="childForm" :rules="childFormRules">
        <el-row>
          <el-col :span="6">
            <el-form-item prop="supplierProductNo" label="供应商产品编码">
              <el-input disabled v-model="childForm.supplierProductNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品名称" prop="productName">
              <SelectTable :disabled="!editMode" :columns="applySupplierProductColumns" :placeholder="'请选择产品'" :innerName="childForm.productName" :dataList="STATIC_ApplySupplierProducts" @filterMethod="getProductList" @change="productChange" />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item prop="isHaveStock" label="目标库房库存>0">
              <el-checkbox :disabled="!editMode" v-model="childForm.isHaveStock" @change="isHaveStockChange"></el-checkbox>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item prop="specName" label="规格型号">
              <el-input disabled v-model="childForm.specName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="productRegistCertName" label="产品注册证">
              <el-input disabled v-model="childForm.productRegistCertName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
    
          <el-col :span="6">
            <el-form-item prop="productRegistCertNo" label="注册证号">
              <el-input disabled v-model="childForm.productRegistCertNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="manufacturerName" label="生产厂家">
              <el-input disabled v-model="childForm.manufacturerName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="onlineNo" label="挂网号">
              <el-input disabled v-model="childForm.onlineNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="brand" label="品牌">
              <el-input disabled v-model="childForm.brand"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
        
          <el-col :span="6">
            <el-form-item prop="stockNumber" label="科室库存">
              <el-input disabled v-model="childForm.stockNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="oneLevelStockNumber" label="目标库房库存">
              <el-input disabled v-model="childForm.oneLevelStockNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="supplierName" label="供应商">
              <el-input disabled v-model="childForm.supplierName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="minUnit" label="最小单位">
              <el-input disabled v-model="childForm.minUnit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
      
          <el-col :span="6">
            <el-form-item prop="unit" label="包装单位">
              <el-input disabled v-model="childForm.unit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="number" label="数量">
              <el-input-number :disabled="!editMode" v-model="childForm.number" :min="0" :precision="2" ref="number" :controls="false" placeholder="请填写数量" @change="childNumberChange" style="width: 100%"></el-input-number>
              <!-- <el-input :disabled="!editMode" placeholder="请输入数量" type="number" min="0" ref="number" v-model="childForm.number" @input="childNumberChange"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="price" label="单价">
              <el-input disabled v-model="childForm.price"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="amount" label="小计">
              <el-input disabled v-model="childForm.amount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
         
          <el-col :span="6">
            <el-form-item prop="packSpec" label="包装规格">
              <el-input :disabled="!editMode" v-model="childForm.packSpec"></el-input>
            </el-form-item>
          </el-col>
   
          <el-col :span="6">
            <el-form-item prop="remark" label="备注">
              <el-input :disabled="!editMode" v-model="childForm.remark"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="medicalInsuranceCategoryNo" label="医保代码">
              <el-input disabled v-model="childForm.medicalInsuranceCategoryNo"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
        
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="">
        <el-button v-if="editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="continueAdd">新增下一条</el-button>
        <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
        <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
  <div slot="footer" class="footer-bottom">
    <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
    <my-button v-if="editMode && form.status != 0" class="btn primary" type="primary" v-preventReClick @click="proTemSave">暂 存</my-button>
    <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
    <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
    <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
  </div>
</div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  GetStockUpPleaseById,
  GetPurchaseApplyById,
  SavePurchaseApply,
  SaveStockUpPlease,
  RejectStockUpPlease,
  GetStockNumber1,
  GetOneLevelStockNumber,
  GetSupplierProducts,
  GetDeptApplyTotalAmount,
  GetWarehousesByDeptId,
} from "@/api";
import {
  InStockOptions,
  AssetSourceOptions,
  PurchaseApplyCategoryOptions,
  OrderPressingOptions,
} from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectTable,
    ApproveInfo,
  },
  data() {
    return {
      form: {},
      InStockOptions: InStockOptions,
      AssetSourceOptions: AssetSourceOptions,
      PurchaseApplyCategoryOptions: PurchaseApplyCategoryOptions,
      OrderPressingOptions: OrderPressingOptions,
      rules: {
        // warehouseName: [
        //   { required: true, message: '请选择仓库', trigger: 'blur' }
        // ],
        applyDeptName: [{
          required: true,
          message: "请选择请领科室",
          trigger: "blur"
        }],
        warehouseName: [{
          required: true,
          message: "请选择目标库房",
          trigger: "blur"
        }, ],
        pressingState: [{
          required: true,
          message: "请选择紧急标识",
          trigger: "blur"
        }],
      },
      childFormRules: {
        productName: [{
          required: true,
          message: "请选择产品",
          trigger: "blur"
        }],
        price: [{
          required: true,
          message: "请输入采购价",
          trigger: "blur"
        }],
        number: [{
            required: true,
            message: "数量不能为空",
            trigger: "blur"
          },
          {
            type: "number",
            min: 0.01,
            message: "数量必须大于0",
            trigger: "blur",
          },
          {
            validator: this.validateLimitNumber,
            trigger: "blur"
          },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      reject: RejectStockUpPlease,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},
      // showCapitalSource: false,
      // showCapitalSourceTwo: false,
      // showCapitalSourceThree: false,
      capitalSourcemaxCount: 0,
      // fileId: 0,
      // fileName: '',
      // openViewer: false,
      isCopy: false,
    };
  },

  created() {
    var query = this.$route.query;
    if (this.system_setting.IsUseWard) {
      this.getDeptAndWards()

    } else {
      this.getDeptsBySessionDeptId("");
    }
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    if (query.isCopy == 1) {
      this.isCopy = true;
    }
  
    // if (query.editMode == 1) {
    //   this.editMode = true
    // }
  
    // this.getWarehouses('')
    // this.getOneLevelWarehouses("");
  },
  methods: {
    // 新建
    handleAdd() {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate(id) {
      GetStockUpPleaseById({
        id
      }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.getLocations(this.form.warehouseId);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);
        
        if (this.isCopy) {
          this.form.id = 0;
          this.form.no = "";
          this.form.status = 2;
          this.form.applyStatus = 0;
          this.form.state = 0;
          this.form.category = 0;
          this.form.workFlowInstanceId = 0;
          let now = this.parseTime(new Date());
          let user = this.userInfo;
          this.form.createdUserName = user.name;
          this.form.createdUser = user.id;
          this.form.ownerDept = user.deptId;
          this.form.ownerDeptName = user.deptName;
          this.form.createdTime = now;
          if (this.form.details) {
            this.form.details.map((item) => {
              item.receivedNumber = 0;
              item.notReceivedNumber = item.number;
              item.state = 0;
              item.stateName = "";

              GetOneLevelStockNumber({
                  supplierProductId: item.supplierProductId,
                  stockCategory: 0,
                  warehouseId: this.form.oneLevelWarehouseId,
                })
                .then((res) => {
                  this.form.details = this.form.details.map((detail) => {
                    if (item.$index == detail.$index) {
                      detail.oneLevelStockNumber = res.returnData.stockNumber;
                    }
                    return detail;
                  });
                })
                .then(() => {
                  return GetStockNumber({
                    supplierProductId: item.supplierProductId,
                    wareHouseId: this.form.warehouseId,
                  });
                })
                .then((res) => {
                  this.form.details = this.form.details.map((detail) => {
                    if (item.$index == detail.$index) {
                      detail.stockNumber = res.returnData.stockNumber;
                    }
                    return detail;
                  });
                });

              return item;
            });
          }
        }
      });
    },
    // 保存
    submit() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }

        if (!this.form.details || this.form.details.length == 0) {
          this.$my_message("明细表不能为空", "warning");
          return;
        }

        let supplierProductIds = this.form.details.map((e) => e.supplierProductId);
        if (!supplierProductIds || supplierProductIds.length == 0) {
          this.$my_message("存在没有供应商产品的明细表", "warning");
          return;
        }

        if (this.form.details) {
          for (var i = 0; i < this.form.details.length; i++) {
            if (
              this.form.details[i].limitNumber &&
              this.form.details[i].number > this.form.details[i].limitNumber
            ) {
              this.$my_message(`第${i + 1}行：申领数量大于申领限额数量`, "warning");
              return false;
            }
          }
        }

        GetSupplierProducts({
            ids: supplierProductIds,
            pageIndex: 1,
            pageSize: 999
          })
          .then((res) => {
            let msg = "";
            for (let i = 0; i < this.form.details.length; i++) {
              let sp = res.returnData.data.find(
                (e) => e.id == this.form.details[i].supplierProductId
              );
              // console.log(sp, 'sp', sp.isEnabled != 1, this.form.details[i].number, this.form.details[i].oneLevelStockNumber)
              if (
                sp &&
                sp.isEnabled != 1 &&
                this.form.details[i].number > this.form.details[i].oneLevelStockNumber
              ) {
                msg = `第${i + 1}行：产品名称 [${this.form.details[i].productName
                  }] 规格型号 [${this.form.details[i].specName
                  }]的产品<span style="color:red">已被禁用</span>，请领数量不能超出目标库房已有库存数量${this.form.details[i].oneLevelStockNumber
                  }`;
                break;
              }
            }

            if (msg) {
              this.$my_message(msg, "warning");
              throw msg;
            }
            return GetDeptApplyTotalAmount({
              deptId: this.form.ownerDept
            })
          })
          // .then((res) => {
          //   let chargeAmount = 0;
          //   let notChargeAmount = 0;
          //   this.form.details.map((item) => {
          //     if (item.billingLogo == 1) {
          //       chargeAmount += item.amount;
          //     } else {
          //       notChargeAmount += item.amount;
          //     }
          //   });
          //   let errMsg = "";
          //   if (
          //     res.returnData.charge &&
          //     chargeAmount > 0 &&
          //     chargeAmount + res.returnData.chargeAmounted > res.returnData.chargeAmount
          //   ) {
          //     errMsg += "计费";
          //   }
          //   if (
          //     res.returnData.notCharge &&
          //     notChargeAmount > 0 &&
          //     notChargeAmount + res.returnData.notChargeAmounted >
          //     res.returnData.notChargeAmount
          //   ) {
          //     if (!errMsg || errMsg == "") {
          //       errMsg = "不计费";
          //     } else {
          //       errMsg += "和不计费";
          //     }
          //   }

          //   if (errMsg) {
          //     return this.$alert(errMsg + "产品已超过计划请领限额，请注意控制！");
          //   }
          // })
          .then((res) => {
            return SaveStockUpPlease(this.form).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
          })
          .then((res) => {
            this.$my_message(`执行成功`, "success");
            sessionStorage.setItem("editMode", 0);
            this.routePushWithParams(
              this.getMainPath(this.$route.path),
              this.$route.params
            );
          });
      });
    },
    resetForm() {
      
      this.form = {
        inStockType: 0,
        supplierName: "",
        assetCheckNo: "",
        assetCheckId: "",
        state: 0,
        pressingState: 0,
        category: 0,
        details: [],
        applyDeptName: this.system_setting.IsUseWard?`${this.mySessionStorage.getDeptName()} ${this.mySessionStorage.getWardName()} `:this.mySessionStorage.getDeptName(),
        applyDeptId: this.mySessionStorage.getDeptId(),
        orgCode :sessionStorage.getItem('orgId'),
        warehouseId: this.mySessionStorage.getWarehouseId(),
        // "warehouseId": this.userInfo.defaultWarehouseId,
        // warehouseName: this.userInfo.defaultWarehouseName,
        // warehouseManagerId: this.userInfo.defaultWarehouseManagerId,
        // warehouseManagerName: this.userInfo.defaultWarehouseManagerName,
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        ownerDept: this.userInfo.deptId,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        wardId:this.system_setting.IsUseWard?this.mySessionStorage.getWardId():'',
      };
      if(this.userInfo.isAdmin){
        this.form.applyDeptName =  this.userInfo.deptName 
        this.form.applyDeptId = this.userInfo.deptId
      }
      // if (
      //   !this.userInfo.isAdmin &&
      //   this.userInfo.deptInfos &&
      //   this.userInfo.deptInfos.length == 1
      // ) 
    
      
      // if(this.userInfo)
      //   if (this.system_setting.IsUseWard){
      //    this.getDeptById(this.userInfo.deptInfos[0].id).then(r=>{
      //     this.form.applyDeptName = `${r[0].name} ${r[0].wards[0].name}`
      //     this.form.wardId = r[0].wards[0].id
      //    })
      //   }else{
      //     this.form.applyDeptName = this.userInfo.deptInfos[0].name;
      //   }
      //   this.form.applyDeptId = this.userInfo.deptInfos[0].id;
      //  this.$forceUpdate();
      // }
      
      
      this.getWarehouseList('')
    },
    // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      // console.log(this.$route)
      // this.$router.push({ name: this.getMainPathName(this.$route.path), params: this.$route.params });
      // let params = this.$route.params
      // console.log(params)
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm() {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();

      this.getProductList("");
    },
    handleDeleteChildForm() {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange(selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick(row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));

      this.getProductList("");
    },

    resetDetailFormData() {
      this.childForm = {
        $index: this.form.details.length + 1,
        supplierProductId: "",
        productName: "",
        productId: "",
        specId: "",
        brand: "",
        supplierId: "",
        manufacturerId: "",
        unit: "",
        minUnit: "",
        stockNumber: 0,
        oneLevelStockNumber: 0,
        number: 0,
        price: 0,
        amount: 0,
        limitNumber: "",
        remark: "",
        isHaveStock: true,
        packSpec: "",
      };

      if (this.form.category == 1) {
        this.childForm.isHaveStock = false;
      }
    },
    cancelChildDialog() {
      this.openSubformModal = false;
    },
    submitChildForm() {
      this.pushChildForm(true);
    },
    continueAdd() {
      this.editChildren = false;
      this.pushChildForm();

      this.getProductList("");
    },
    pushChildForm(close) {
      this.$refs["childForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        // this.capitalSourceChange()
        let item = this.form.details.find(
          (e) =>
          e.$index != this.childForm.$index &&
          e.supplierProductId == this.childForm.supplierProductId //&&
          // e.price == this.childForm.price &&
          // e.locationName == this.childForm.locationName &&
          // e.assetSource == this.childForm.assetSource &&
          // e.packDesc == this.childForm.packDesc &&
          // e.manufacturerId == this.childForm.manufacturerId &&
          // e.certId == this.childForm.certId &&
          // e.brandId == this.childForm.brandId
        );
        if (item && !this.editChildren) {
          // 新增有重复项提示
          // Object.assign(item, this.childForm);
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (item && this.editChildren) {
          // 编辑且有重复项
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (!item && this.editChildren) {
          // 编辑
          item = this.form.details.find((e) => e.$index == this.childForm.$index);
          Object.assign(item, this.childForm);
        } else {
          this.form.details.push(this.childForm);
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
        }
      });
    },
    childNumberChange() {
      this.childForm.notReceivedNumber = this.childForm.number;
      this.childForm.planOrderNumber = this.childForm.number;
      this.childForm.actualOrderNumber = this.childForm.number;
      this.autoAmount();
    },
    autoAmount() {
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(4) * 1;
      this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount() {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
      this.form.unBillNumber = totalNumber;
      this.form.unBillAmount = totalAmount;
    },

    // change event
    // warehouseChange (val) {
    //   let item = this.STATIC_Warehouses.find((e) => e.id == val);
    //   if (item) {
    //     this.form.warehouseId = item.id;
    //     this.form.warehouseManagerId = item.managerId;
    //     this.form.warehouseManagerName = item.managerName;
    //   }

    //   this.getLocations(val);
    // },

    applyDeptChange1(val){
      let arr = this.STATIC_DeptAndWards.filter(res=>res.idGroup == val)
      this.form.applyDeptName =  arr[0].deptName + " " + (arr[0].wardName?arr[0].wardName:'');
      this.form.applyDeptId = arr[0].deptId
      this.form.wardId = arr[0].wardId
      this.getWarehouseList('')
      this.getProductList('')
    },
 
    applyDeptChange(val) {
      this.form.applyDeptId = val;
      this.getWarehouseList('')
      this.getProductList('')
    },
    oneLevelWarehouseChange(val) {
      let item = this.STATIC_OneLevelWarehouses.find((e) => e.id == val);
      if (item) {
        this.form.warehouseId = item.id
        this.form.warehouseName = item.name
        this.form.warehouseManagerId = item.managerId;
        this.form.warehouseManagerName = item.managerName;
      }
      this.form.details = [];
      this.getProductList("");
    },
    locationChange(val) {
      let item = this.STATIC_Locations.find((e) => e.id == val);
      if (item) {
        this.childForm.locationName = item.name;
      }
    },
    isHaveStockChange() {
      this.getProductList("");
    },
    productChange(row) {
      let id = this.childForm.id;
      let arr = this.STATIC_ApplySupplierProducts.filter((item) => item.id == row.id);
      this.childForm = Object.assign(this.childForm, row);
      this.childForm.id = id;
      this.childForm.supplierProductId = row.id;
      this.childForm.number = 1;
      this.childForm.receivedNumber = 0;
      this.childForm.notReceivedNumber = 1;
      this.childForm.planOrderNumber = 1;
      this.childForm.actualOrderNumber = 1;
      this.childForm.oneLevelStockNumber = this.childForm.stockQuantity
      this.childForm.price = this.childForm.purchasePrice;
      this.childForm.amount = this.childForm.price;
      this.childForm.supplierProductNo = this.childForm.no;
      this.childForm.remark = "";
      console.log(arr);
     
      setTimeout(() => {
        this.$refs.number.focus();
        this.$refs.number.select();
      }, 1);

      this.childForm.stockNumber = 0;

      // let stockQuey = {
      //   supplierProductId: arr[0].id,
      //   warehouseId: this.form.warehouseId == "" ? 0 : this.form.warehouseId
      // }
        GetWarehousesByDeptId({deptId:this.form.applyDeptId}).then(res=>{
          GetStockNumber1({
            stockCategory:1,
            supplierProductId: arr[0].id,
            warehouseId: res.returnData.id,
          }).then((res) => {
            this.childForm.stockNumber = res.returnData.stockNumber;
          });
       
      })
      
       

      // var warehouseId = this.form.oneLevelWarehouseId;
      // if (!warehouseId) {
      //   warehouseId = "";
      // }

   
      // GetOneLevelStockNumber({
      //   supplierProductId: arr[0].id,
      //   stockCategory: 0,
      //   warehouseId: warehouseId,
      // }).then((res) => {
      //   this.childForm.oneLevelStockNumber = res.returnData.stockNumber;
      // });

      this.$refs.childForm.validateField("productName");
    },

    getProductList(keyWord) {
      if (!this.form.applyDeptId) {
        this.STATIC_ApplySupplierProducts = []
        return
      }
      let warehouseId = "";
      if (this.form.warehouseId) {
        warehouseId = this.form.warehouseId;
      }

      // let user = this.userInfo;

      // query.pageIndex = 1
      // query.pageSize = 50
      // query.deptId = user.deptId
      // query.warehouseId = warehouseId
      // query.isHaveStock = 1
      // query.status = 2
      let query = {
        keyWord: keyWord,
        pageIndex: 1,
        pageSize: 50,
        // isEnabled: 0,
        supplierApproveStates: [2],
        deptId: this.form.applyDeptId,
        warehouseId: warehouseId,
        isHaveStock: 1,
        status: 2,
        stockCategory:1,

      };

      // 忽略目标库房有库存，需要启用的供应商产品；目标库房有库存，可以选到禁用的供应商产品
      if (this.childForm && !this.childForm.isHaveStock) {
        query.isHaveStock = 0;
        query.isEnabled = 1;
      }

      this.getApplySupplierProducts(query);
      
    },
    getWarehouseList(keyWord) {
      if (this.form.applyDeptId) {
        this.getOneLevelWarehousesByOneLevelDeptId(keyWord, this.form.applyDeptId)
      } else {
        this.STATIC_OneLevelWarehouses = []
      }
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
